import {Injectable} from '@angular/core';
import {AbstractMapper} from '../../abstract.mapper';
import {PersonWeitereAngaben, StammdatenNatuerlichePerson} from '@nachdigal';

@Injectable()
export class PersonWeitereAngabenMapperService
  extends AbstractMapper<StammdatenNatuerlichePerson, PersonWeitereAngaben> {

  constructor() {
    super();
  }

  protected mapInternal(source: StammdatenNatuerlichePerson): PersonWeitereAngaben {

    return {
      geburtsdatum: source.geburtsdatum,
      identifikationsnummer: source.identifikationsnummer
    };
  }
}
